import { SSMClient, GetParametersCommand } from "@aws-sdk/client-ssm";
import { Auth } from 'aws-amplify';
import config from '../aws-exports';
import { Mutex } from 'async-mutex';

let clientLock = new Mutex();

const paramsNeeded = [
    "INR_TO_USD"
];

const paramsDirectNeeded = [
];

const noParse = [
];

var paramsLoaded;
var paramsLoadedTs;

const getParams = async (params, credentials, region) => {
    const parameterStore = new SSMClient({
        apiVersion: '2014-11-06',
        region: region,
        credentials: credentials
    });
    try {
        const data = await parameterStore.send(
            new GetParametersCommand({
                Names: params
            })
        );
        return data.Parameters;
    } catch (err) {
        console.error(err);
        throw err;
    }
};

function sliceIntoChunks(arr, chunkSize) {
    const res = [];
    for (let i = 0; i < arr.length; i += chunkSize) {
        const chunk = arr.slice(i, i + chunkSize);
        res.push(chunk);
    }
    return res;
}

function isCacheValid() {
    if (paramsLoadedTs === undefined) {
        return false;
    }
    const now = new Date();
    const msBetweenDates = Math.abs(paramsLoadedTs.getTime() - now.getTime());
    const secBetweenDates = msBetweenDates / 1000;
    if (secBetweenDates > 300) {
        return false;
    }
    return true;
}

export async function getParameterFromManager(paramName) {
    var backend = config.aws_user_files_s3_bucket.split('-');
    var env = backend[backend.length - 1];
    
    // Check if we need to load/reload parameters
    if ((paramsLoaded === undefined) || (isCacheValid() === false)) {
        // Acquire lock to prevent multiple simultaneous loads
        let release = await clientLock.acquire();
        
        // Double-check after acquiring lock (another call might have loaded it)
        if ((paramsLoaded === undefined) || (isCacheValid() === false)) {
            try {
                console.log('[Utils] Loading SSM parameters...');
                paramsLoaded = undefined;
                
                var credentials = await Auth.currentCredentials();
                var params = Array.from(paramsNeeded, x => `${x}-${env}`).concat(paramsDirectNeeded);
                var chunkParams = sliceIntoChunks(params, 10);
                
                for (var i = 0; i < chunkParams.length; i++) {
                    var paramsLoadedResp = await getParams(chunkParams[i], credentials, config.aws_project_region);
                    if (paramsLoaded === undefined) {
                        paramsLoaded = paramsLoadedResp;
                    } else {
                        paramsLoaded = paramsLoaded.concat(paramsLoadedResp);
                    }
                }
                
                paramsLoadedTs = new Date();
                console.log('[Utils] SSM parameters loaded successfully');
            } catch (error) {
                console.error('[Utils] Error loading SSM parameters:', error);
                // Set empty array to prevent repeated failures
                paramsLoaded = [];
                paramsLoadedTs = new Date();
                throw error;
            } finally {
                release();
            }
        } else {
            // Another call loaded it while we were waiting
            release();
        }
    }
    var existParam = paramsLoaded.filter(obj => {
        return obj.Name === `${paramName}-${env}`;
    });
    if (existParam !== undefined && existParam.length > 0) {
        if (noParse.includes(paramName)) {
            return existParam[0].Value;
        } else {
            return JSON.parse(existParam[0].Value);
        }
    } else {
        existParam = paramsLoaded.filter(obj => {
            return obj.Name === `${paramName}`;
        });
        if (existParam !== undefined && existParam.length > 0) {
            if (noParse.includes(paramName)) {
                return existParam[0].Value;
            } else {
                return JSON.parse(existParam[0].Value);
            }
        }
    }
    console.log(`paramName: ${paramName} is not found`);
    return null;
}

export async function updateParameterInManager(paramName, newValue) {
    var backend = config.aws_user_files_s3_bucket.split('-');
    var env = backend[backend.length - 1];
    if (paramsLoaded === undefined)
        return;
    var existParam = paramsLoaded.filter(obj => {
        return obj.Name === `${paramName}-${env}`;
    });
    if (existParam !== undefined && existParam.length > 0) {
        if (noParse.includes(paramName)) {
            existParam[0].Value = newValue;
            console.log(`paramName: ${paramName} updated in store`);
            return;
        } else {
            existParam[0].Value = JSON.parse(newValue);
            console.log(`paramName: ${paramName} updated in store`);
            return;
        }
    } else {
        existParam = paramsLoaded.filter(obj => {
            return obj.Name === `${paramName}`;
        });
        if (existParam !== undefined && existParam.length > 0) {
            if (noParse.includes(paramName)) {
                existParam[0].Value = newValue;
                console.log(`paramName: ${paramName} updated in store`);
                return;
            } else {
                existParam[0].Value = JSON.parse(newValue);
                console.log(`paramName: ${paramName} updated in store`);
                return;
            }
        }
    }
    console.log(`paramName: ${paramName} is not found`);
    return null;
}
